import React, {useState, useRef, useEffect} from 'react'
import ReactDOM from 'react-dom'

function DropdownMenu({actions, onActionPerformed, buttonRect, menuRef}) {
  if (!buttonRect) return null

  return ReactDOM.createPortal(
    <div
      ref={menuRef}
      style={{
        position: 'absolute',
        top: `${buttonRect.bottom + window.scrollY}px`,
        left: `${buttonRect.left + window.scrollX}px`,
        zIndex: 1000,
        background: '#fff',
        boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
        borderRadius: '4px',
        padding: '5px 0',
        minWidth: '120px',
      }}
    >
      {actions && actions.length ? (
        actions.map((action, i) => (
          <button
            key={i}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '5px 10px',
              width: '100%',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '14px',
            }}
            onClick={() => onActionPerformed(action)}
          >
            {action.icon && <i className={`mdi ${action.icon}`} style={{marginRight: '8px'}} />}
            {action.title || action.name}
          </button>
        ))
      ) : (
        <div style={{padding: '5px', color: 'gray'}}>No Action Available</div>
      )}
    </div>,
    document.body
  )
}

export default function ActionDropdown({actions, onActionPerformed}) {
  const [actionsOpen, setActionsOpen] = useState(false)
  const [buttonRect, setButtonRect] = useState(null)
  const containerRef = useRef(null)
  const menuRef = useRef(null)

  const handleOpen = (e) => {
    e.stopPropagation()
    setButtonRect(e.currentTarget.getBoundingClientRect())
    setActionsOpen(true)
  }

  const handleClose = () => {
    setActionsOpen(false)
    setButtonRect(null)
  }

  // click-away listener
  useEffect(() => {
    const handleClickOutside = (event) => {
      const target = event.target
      if (
        containerRef.current &&
        !containerRef.current.contains(target) &&
        menuRef.current &&
        !menuRef.current.contains(target)
      ) {
        handleClose()
      }
    }
    if (actionsOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [actionsOpen])

  return (
    <div ref={containerRef} style={{position: 'relative', display: 'inline-block'}}>
      <button
        onClick={actionsOpen ? handleClose : handleOpen}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '5px',
        }}
      >
        <i className='mdi mdi-dots-horizontal' style={{fontSize: '20px'}} />
      </button>

      {actionsOpen && buttonRect && (
        <DropdownMenu
          actions={actions}
          onActionPerformed={(action) => {
            onActionPerformed(action)
            handleClose()
          }}
          buttonRect={buttonRect}
          menuRef={menuRef}
        />
      )}
    </div>
  )
}
